import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Button,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Teams } from "src/_mock/teams";
import { useNavigate } from "react-router-dom";
import TeamsTableBody from "src/components/teams/TeamsTableBody";
import TeamsFilters from "src/components/teams/TeamsFilters";

const TeamsPageAssets = () => {
  const inputStyles = {
    borderRadius: "50px",
    boxShadow: "0.5px 3px 10px 0px #7777771A",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "50px",
      borderColor: "#ccc",
    },
    "& .MuiInputBase-input": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#6A707E",
    },
    "& .MuiInputLabel-root": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
  };

  const [teams, setTeams] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSport, setSelectedSport] = useState("");
  const [selectedLeague, setSelectedLeague] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedPosition, setSelectedPosition] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuTeamsId, setMenuTeamsId] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event, teamsId) => {
    setAnchorEl(event.currentTarget);
    setMenuTeamsId(teamsId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuTeamsId(null);
  };

  const handleEdit = (teamsId) => {
    navigate(`/dashboard/assets/teams/${teamsId}`);
    handleMenuClose();
  };

  const handleAdd = () => {
    navigate("/dashboard/assets/teams/new");
  };

  const handleDelete = () => {
    handleMenuClose();
  };

  useEffect(() => {
    setTeams(Teams);
  }, []);

  const filteredTeams = teams.filter((team) => {
    return (
      (team.teamName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        team.nickname.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (selectedSport === "" || team.sport === selectedSport) &&
      (selectedLeague === "" || team.league === selectedLeague) &&
      (selectedTeam === "" || team.teamName === selectedTeam) &&
      (selectedPosition === "" || team.position === selectedPosition)
    );
  });

  const getUniqueValues = (key) => {
    const values = teams.map((p) => p[key]).filter(Boolean);
    return [...new Set(values)];
  };

  return (
    <Container>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          mb: 5,
        }}
      >
        Teams
      </Typography>

      <TeamsFilters
        inputStyles={inputStyles}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedSport={selectedSport}
        setSelectedSport={setSelectedSport}
        selectedLeague={selectedLeague}
        setSelectedLeague={setSelectedLeague}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        selectedPosition={selectedPosition}
        setSelectedPosition={setSelectedPosition}
        handleAdd={handleAdd}
        getUniqueValues={getUniqueValues}
      />

      <TableContainer>
        <Table sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Logo
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  display: "flex",
                  alignItems: "center",
                  color: "#464A53",
                }}
              >
                <Box display="flex" alignItems="center">
                  Team Name
                  <Box ml={0.5} display="flex" flexDirection="column">
                    <Button size="small" sx={{ minWidth: 0, padding: 0 }}>
                      <KeyboardArrowUpIcon fontSize="small" />
                    </Button>
                    <Button size="small" sx={{ minWidth: 0, padding: 0 }}>
                      <KeyboardArrowDownIcon fontSize="small" />
                    </Button>
                  </Box>
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Nickname
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Tri-Code
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Sport
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                League
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Country
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "none",
                  color: "#464A53",
                }}
              >
                Players
              </TableCell>
            </TableRow>
          </TableHead>
          <TeamsTableBody teams={filteredTeams} onMenuOpen={handleMenuOpen} />
        </Table>
      </TableContainer>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleEdit(menuTeamsId)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleDelete(menuTeamsId)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </Container>
  );
};

export default TeamsPageAssets;
